import React, { useState } from 'react';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { useSnackbar } from 'material-ui-snackbar-provider';
import CheckIcon from '@mui/icons-material/Check';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { getPreviewAccessToken, removePreviewAccessToken, setFinishPreviewUserId } from '../../../../helpers';
import { ReactComponent as EyeIcon } from '../../../../assets/icons/eye.svg';
import { saveMyOrganization } from '../../../../store/user/userSlice';
import { useAppSelector } from '../../../../store/hooks';
import { getUserOrganization } from '../../../../api';
import styles from './PreviewModeButtons.module.scss';
import { PATHS } from '../../../../enums';
import { Tooltip } from '@material-ui/core';

type TPreviewModeButtons = {
  minimizedPreviewMode: boolean;
};

const PreviewModeButtons: React.FC<TPreviewModeButtons> = ({ minimizedPreviewMode }) => {
  const { currentUser } = useAppSelector((state) => state.user);
  const isPreview = getPreviewAccessToken();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const notification = useSnackbar();

  const fetchOrganization = async () => {
    try {
      const { data } = await getUserOrganization();
      dispatch(saveMyOrganization(data));
    } catch (err) {
      console.log(`Error: `, err);
    }
  };

  const handleGoBack = () => {
    removePreviewAccessToken();

    fetchOrganization();

    history.push(encodeURI(`${PATHS.SA_USERS_LIST.path}`));
    window.location.reload();
  };

  const handleFinishSupport = () => {
    removePreviewAccessToken();
    currentUser && setFinishPreviewUserId(+currentUser.id);
    fetchOrganization();

    history.push(encodeURI(`${PATHS.SA_USERS_LIST.path}`));
    window.location.reload();
  };

  return (
    <>
      {!minimizedPreviewMode ? (
        <div className={styles.buttonsContainer}>
          <div className={styles.goBack} onClick={handleGoBack}>
            <ArrowBackIosNewRoundedIcon style={{ height: '16px', width: '16px' }} />
            <div>Go Back </div>
          </div>
          <Tooltip title={`${currentUser?.need_help}`}>
            <div className={styles.previewUser}>
              <EyeIcon className={styles.previewEye} />
              <div>Now Helping: {currentUser?.username}</div>
            </div>
          </Tooltip>
          <div className={styles.finish} onClick={handleFinishSupport}>
            <CheckIcon style={{ height: '16px', width: '16px' }} />
            <div>Finish support</div>
          </div>
        </div>
      ) : (
        <div className={styles.buttonsContainer}>
          <Tooltip arrow title="Go Back">
            <div className={styles.goBack} onClick={handleGoBack}>
              <ArrowBackIosNewRoundedIcon style={{ height: '16px', width: '16px' }} />
            </div>
          </Tooltip>
          <Tooltip
            title={
              <>
                Now Helping: ${currentUser?.username}
                <br />
                User Message: ${currentUser?.need_help}`
              </>
            }
          >
            <div className={styles.previewUser}>
              <EyeIcon className={styles.previewEye} />
            </div>
          </Tooltip>
          <Tooltip arrow title={'Finish support'}>
            <div className={styles.finish} onClick={handleFinishSupport}>
              <CheckIcon style={{ height: '13px', width: '13px' }} />
            </div>
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default PreviewModeButtons;
